import { useRef, useCallback } from "react";
/**
 * useObserver
 * @param callback IntersectionObserverCallback
 * @param options IntersectionObserverInit
 * @param externalState React.ComponentState[]
 */
const useObserver = function (callback) {
  let {
    root,
    rootMargin,
    threshold
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let externalState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  const target = useRef(null);
  const observer = useRef(null);
  const setTarget = useCallback(node => {
    if (target.current && observer.current) {
      observer.current.unobserve(target.current);
      observer.current.disconnect();
      observer.current = null;
    }
    if (node) {
      observer.current = new IntersectionObserver(callback, {
        root,
        rootMargin,
        threshold
      });
      observer.current.observe(node);
      target.current = node;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, root, rootMargin, JSON.stringify(threshold), ...externalState]);
  return setTarget;
};
export default useObserver;